export default __webpack_public_path__ + "device_stick_up_cam_wired.3c678bc4.png";